import { privacy } from "@redotech/schema-privacy";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum VariantExchangeGuidanceLevel {
  COLLECTION = "collection",
  TAG = "tag",
  TEAM = "team",
  PRODUCT = "product",
}

export const VariantExchangeGuidanceSchema = z.object({
  guidanceLevel: createEnum(VariantExchangeGuidanceLevel, {
    enumName: "VariantExchangeGuidanceLevel",
  }).meta({ privacy: privacy.nonPii }),
  guidanceLevelId: z.string().meta({ privacy: privacy.nonPii }),
  guidance: z.string().meta({ privacy: privacy.nonPii }),
  enabled: z.boolean().meta({ privacy: privacy.nonPii }),
});
export type VariantExchangeGuidance = z.infer<
  typeof VariantExchangeGuidanceSchema
>;

export function areVariantExchangeGuidanceIdentifiersEqual(
  a: VariantExchangeGuidance,
  b: VariantExchangeGuidance,
): boolean {
  return (
    a.guidanceLevel === b.guidanceLevel &&
    a.guidanceLevelId === b.guidanceLevelId
  );
}

export function areVariantExchangeGuidanceEqual(
  a: VariantExchangeGuidance,
  b: VariantExchangeGuidance,
): boolean {
  return (
    areVariantExchangeGuidanceIdentifiersEqual(a, b) &&
    a.enabled === b.enabled &&
    a.guidance.trim() === b.guidance.trim()
  );
}
